import { BADGE_VARIANTS, Badge } from 'ui/badge';
import { InfoBanner } from 'ui/banner';
import { IdType, ImportType } from 'modules/domains/adminApp';

import { FormFieldKey, FormState } from './types';
import { DISABLED, ENABLED, ORGANIZATION, PROJECT } from './constants';
import { useFeatureContext } from './FeatureContext';

type ImportDetailsProps = Pick<FormState, FormFieldKey.IdType | FormFieldKey.ImportType>;

export const ImportDetails = ({ idType, importType }: ImportDetailsProps) => {
  const isEnabling = importType === ImportType.EnableFeature;
  const enabledOrDisabled = isEnabling ? ENABLED : DISABLED;
  const enabledOrDisabledBadgeVariant = isEnabling
    ? BADGE_VARIANTS.RUNNING
    : BADGE_VARIANTS.ABORTED;
  const projectOrOrganization = idType === IdType.Project ? PROJECT : ORGANIZATION;
  const {
    featureFlag: { feature },
  } = useFeatureContext();

  return (
    <>
      <p>
        You are about to change feature availability for <b>{feature}</b>. Review the following
        details before saving.
      </p>
      <InfoBanner isSubtle>
        This feature will be{' '}
        <Badge variant={enabledOrDisabledBadgeVariant}>{enabledOrDisabled}</Badge> for all existing{' '}
        <b>{projectOrOrganization} IDs</b> imported from the DB.
      </InfoBanner>
      <InfoBanner isSubtle>
        This will not affect {projectOrOrganization}s that are created after the import is
        completed.
      </InfoBanner>
    </>
  );
};
